<template>
  <div class="page-container staff-page">
    <div :class="{ 'multi-choose--active': isActiveMultiChoose }" class="multi-choose">
      <div class="multi-choose__close" @click.stop="onCloseMultiChoose"></div>
      <div class="multi-choose__offers">
        <div class="offer-type export-offer" @click.stop="exportObjects('ids')">Экспортировать выбранные</div>
        <div class="offer-type delete-offer" @click.stop="onDeleteObjects">Удалить выбранные</div>
      </div>
    </div>

    <delete-info
      v-if="isActiveDeleting"
      object-name="сотрудника(-ов)"
      @onCancelDeleting="onCancelDeleting"
      @closeDeleteInfo="closeDeleteInfo"
    />

    <div class="table-wrapper" :class="{ 'upload-data': uploadData }">
      <circle-loader v-if="uploadData" size="xlarge" :indeterminate="true" />

      <div class="table-header">
        <div class="table-header__titles">
          <div class="up">Всего</div>
          <div class="down">{{ objectsData.count }}</div>
        </div>

        <table-paginator :max-count="objectsData.count" :page-size="15" />

        <i class="spacer" />

        <div class="table-header__buttons">
          <button type="button" class="table-header__button add-button" @click.stop="onEnableEditMode('new')">
            Добавить
          </button>
          <button type="button" class="table-header__button export-button" @click.stop="exportObjects">
            Экспорт
          </button>
          <button type="button" class="table-header__button config-button" @click.stop="toggleTableConfig()"></button>
          <div v-if="showTableConfigs" class="table-config" @click.stop>
            <div class="table-config__head">
              <div class="head-title">Столбцы</div>
              <div class="all-button" @click.stop="onSetChangeColumnsAll()">Все</div>
              <div class="close-button" @click.stop="toggleTableConfig()"></div>
            </div>
            <div class="table-config__list">
              <ul>
                <li
                  v-for="(column, index) in columnsConfig"
                  :key="`table-config-item-${index}`"
                  :class="{ 'not-active': !column.isActive }"
                  @click.stop="onChangeActiveColumnConfig(column)"
                >
                  {{ column.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="table-body table-body__with-scroll">
        <table>
          <thead>
            <tr>
              <th class="table-row-selection">
                <div>&nbsp;</div>
              </th>
              <template v-for="column in columnsConfig">
                <th
                  v-if="column.isActive"
                  :key="column.key"
                  :class="{
                    th__active:
                      smartFilterSelected[column.key] &&
                      initialContainerSuggestionDataOption[column.key] &&
                      smartFilterSelected[column.key].length > 1 &&
                      initialContainerSuggestionDataOption[column.key].length !== smartFilterSelected[column.key].length
                  }"
                >
                  <div>
                    <span
                      v-if="
                        !smartFilterSelected[column.key] ||
                          smartFilterSelected[column.key].length === 0 ||
                          smartFilterSelected[column.key].length > 1
                      "
                      @click="onSortTable(column)"
                    >
                      <span class="text">{{ column.name }}</span>
                      <div
                        v-if="ordering.key === column.key && ordering.type !== 'NONE'"
                        :class="ordering.type"
                        class="table-order"
                      />
                    </span>
                    <smart-filter
                      v-if="columnsForSmartFilter[column.key]"
                      :column-key="column.key"
                      suggestions-url="/api/staff/suggestion"
                      :smart-filter-selected="smartFilterSelected"
                      :search-with-filters-function-name="searchWithFiltersFunctionName"
                      :columns-smart-filters-was-opened="columnsSmartFiltersWasOpened"
                      :initial-container-suggestion-data-option="initialContainerSuggestionDataOption"
                      :show-smart-filter="showSmartFilter[column.key]"
                    />
                  </div>
                </th>
              </template>
              <th class="table-actions">
                <div>&nbsp;</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in objectsData.results" :key="`table-body-column-${item.id}`" :class="`tr-elem-${item.id}`">
              <td class="table-row-selection">
                <form-checkbox :checked="item.isActive" @change="onCheckItem(item, item.id)" />
              </td>
              <template v-for="(column, rowIndex) in columnsConfig">
                <td
                  v-if="column.isActive"
                  :key="`table-body-column-${item.id}-row-${rowIndex}`"
                  :class="{ 'has-children': item.has_children }"
                  @dblclick="onEnableEditMode(item.id)"
                >
                  <span v-if="column.key === 'full_name'">{{ replaceIfEmpty(item.full_name, "–") }}</span>
                  <span v-else-if="column.key === 'employee_number'">{{ replaceIfEmpty(item.employee_number, "–") }}</span>
                  <span v-else-if="column.key === 'positions'">{{ getPositionsNames(item.positions) }}</span>
                  <span v-else-if="column.key === 'phone'">{{ replaceIfEmpty(item.phone, "–") }}</span>
                  <span v-else-if="column.key === 'email'">{{ replaceIfEmpty(item.email, "–") }}</span>
                  <div v-else>&nbsp;</div>
                </td>
              </template>
              <td class="table-actions">
                <button type="button" class="edit-button" @click="onEnableEditMode(item.id)" />
                <button type="button" class="delete-button" @click="onDeleteObject(item.id)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";

import AsyncTablePaginator from "../../../../components/AsyncTablePaginator";
import DeleteInfo from "../../../../components/DeleteInfo";
import SmartFilter from "../../../../components/SmartFilter";
import CircleLoader from "../../../../components/CircleLoader";
import FormCheckbox from "../../../../components/forms/NewFormCheckbox";
import { formatMixins } from "../../../../mixins";
import { saveAsXLSX } from "../../../../common";

export default {
  name: "StaffTable",
  components: {
    TablePaginator: AsyncTablePaginator,
    DeleteInfo,
    SmartFilter,
    CircleLoader,
    FormCheckbox
  },
  mixins: [formatMixins],
  data() {
    return {
      showTableConfigs: false,
      columnsConfig: [
        {
          isActive: true,
          name: "ФИО сотрудника",
          key: "full_name"
        },
        {
          isActive: true,
          name: "Табельный номер",
          key: "employee_number"
        },
        {
          isActive: true,
          name: "Должность",
          key: "positions"
        },
        {
          isActive: true,
          name: "Телефон",
          key: "phone"
        },
        {
          isActive: true,
          name: "E-mail",
          key: "email"
        }
      ],
      ordering: {
        key: "",
        type: "NONE"
      },
      isActiveDeleting: false,
      deletingCanceled: false,
      isActiveMultiChoose: false,
      checkedTrIndex: [],
      checkedTrIndexOption: [],
      checkedItemIds: {},
      smartFilterSelected: {},
      columnsSmartFiltersWasOpened: {
        full_name: false,
        employee_number: false,
        position: false,
        phone: false,
        email: false
      },
      initialContainerSuggestionDataOption: {},
      columnsForSmartFilter: {
        full_name: false,
        employee_number: false,
        position: false,
        phone: false,
        email: false
      },
      showSmartFilter: {
        full_name: false,
        employee_number: false,
        position: false,
        phone: false,
        email: false
      },
      searchWithFiltersFunctionName: "onSearchObjects"
    };
  },
  computed: {
    ...mapState("staff", ["objectsData", "uploadData"]),
    currentPage() {
      return this.$store.getters["hashManager/getRouteOption"]({ route: this.$route, option: "page" }) || 1;
    },
    pageOptions() {
      return this.$store.getters["hashManager/getRouteOptions"](this.$route);
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (newValue === oldValue) return;

      axios.cancel("routes-staff");
      this.setUploadData(true);

      const filterParams = Object.entries(this.smartFilterSelected).reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
          acc[key] = value.join();
        }
        return acc;
      }, {});

      this.getObjectListData({
        params: {
          ...filterParams,
          page: newValue
        }
      }).then(response => {
        this.onRebuildCheckbox();

        if (response && response.status && response.status === 200) {
          this.setUploadData(false);
        } else {
          if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
            this.setUploadData(false);
          }
        }
      });
    }
  },
  mounted() {
    if (this.objectsData.results.length === 0) {
      axios.cancel("routes-staff");
      this.setUploadData(true);

      this.getObjectListData().then(response => {
        if (response && response.status && response.status === 200) {
          this.setUploadData(false);
        } else {
          if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
            this.setUploadData(false);
          }
        }
      });
    }

    this.$root.$on("changeShowSmartFilterValue", object => {
      this.showSmartFilter[object.columnKey] = object.value;

      for (const columnKey in this.showSmartFilter) {
        if (columnKey !== object.columnKey) {
          this.showSmartFilter[columnKey] = false;
        }
      }
    });

    this.$root.$on("updateSmartFilterSelected", (key, newValue, isPushingNewElement) => {
      if (isPushingNewElement) {
        this.smartFilterSelected[key].push(newValue);
      } else {
        this.smartFilterSelected[key] = newValue;
      }
    });

    this.$root.$on("initialContainerSuggestionDataOption", object => {
      this.initialContainerSuggestionDataOption[object.columnKey] = object.value;
    });

    this.$root.$on("uploadDataValueChanging", boolean => {
      this.setUploadData(boolean);
    });

    this.$root.$on(this.searchWithFiltersFunctionName, () => this[this.searchWithFiltersFunctionName]());
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "UpdateStaff" || to.name === "ViewStaff") {
      next();
    } else {
      this.updateRouteOptions({ route: this.$route, options: { ...this.pageOptions, page: 1 } });
      next();
    }
  },
  beforeDestroy() {
    axios.cancel("routes-staff");

    this.$root.$off("changeShowSmartFilterValue");
    this.$root.$off("updateSmartFilterSelected");
    this.$root.$off("initialContainerSuggestionDataOption");
    this.$root.$off("uploadDataValueChanging");
    this.$root.$off(this.searchWithFiltersFunctionName);
  },
  methods: {
    ...mapActions("staff", ["getObjectListData", "deleteObject", "makeExport", "searchObjects", "startEditing"]),
    ...mapMutations("staff", ["setUploadData", "setObjectList", "removeElementFromList"]),
    ...mapMutations("hashManager", ["updateRouteOptions"]),
    onCheckItem(item, index) {
      this.setObjectList(
        this.objectsData.results.map(s => {
          if (s.id === item.id) {
            s.isActive = !item.isActive;
            this.checkedItemIds[item.id] = item.isActive;
          }
          return s;
        })
      );

      if (this.checkedTrIndex.indexOf(index) > -1) {
        this.checkedTrIndex = this.checkedTrIndex.filter(s => s !== index);
      } else {
        this.checkedTrIndex.push(index);
      }

      if (this.checkedTrIndex.length > 1) {
        this.isActiveMultiChoose = true;
      } else {
        this.isActiveMultiChoose = false;
      }

      this.checkedTrIndex.sort((a, b) => a - b);
      this.checkedTrIndexOption = this.checkedTrIndex.reduce((acc, cur) => {
        if (acc.length === 0) {
          acc.push([cur]);
        } else {
          const arr = acc[acc.length - 1];
          if (arr[arr.length - 1] === cur - 1) {
            acc[acc.length - 1].push(cur);
          } else {
            acc.push([cur]);
          }
        }
        return acc;
      }, []);
      $(".tr-elem-top").removeClass("tr-elem-top");
      $(".tr-elem-bottom").removeClass("tr-elem-bottom");
      this.checkedTrIndexOption.map(elem => {
        document.getElementsByClassName(`tr-elem-${elem[0]}`)[0].classList.add("tr-elem-top");
        document.getElementsByClassName(`tr-elem-${elem[elem.length - 1]}`)[0].classList.add("tr-elem-bottom");
      });
    },
    onRebuildCheckbox() {
      this.onCloseMultiChoose();
      this.checkedTrIndex = [];
      this.objectsData.results.map((el, index) => {
        if (this.checkedItemIds[el.id]) {
          this.checkedTrIndex.push(index);
        }
      });
      if (this.checkedTrIndex.length > 1) {
        this.isActiveMultiChoose = true;
      } else {
        this.isActiveMultiChoose = false;
      }
      this.checkedTrIndexOption = this.checkedTrIndex.reduce((acc, cur) => {
        if (acc.length === 0) {
          acc.push([cur]);
        } else {
          const arr = acc[acc.length - 1];
          if (arr[arr.length - 1] === cur - 1) {
            acc[acc.length - 1].push(cur);
          } else {
            acc.push([cur]);
          }
        }
        return acc;
      }, []);
      $(".tr-elem-top").removeClass("tr-elem-top");
      $(".tr-elem-bottom").removeClass("tr-elem-bottom");
      this.checkedTrIndexOption.map(elem => {
        document.getElementsByClassName(`tr-elem-${elem[0]}`)[0].classList.add("tr-elem-top");
        document.getElementsByClassName(`tr-elem-${elem[elem.length - 1]}`)[0].classList.add("tr-elem-bottom");
      });
      this.setObjectList(
        this.objectsData.results.map(el => {
          if (this.checkedItemIds[el.id]) {
            el.isActive = true;
          }
          return el;
        })
      );
    },
    onCloseMultiChoose(type) {
      this.setObjectList(
        this.objectsData.results.map(s => {
          s.isActive = false;
          if (type) {
            this.checkedItemIds[s.id] = false;
          }
          return s;
        })
      );
      this.checkedTrIndex = [];
      this.isActiveMultiChoose = false;
      $(".tr-elem-top").removeClass("tr-elem-top");
      $(".tr-elem-bottom").removeClass("tr-elem-bottom");
    },
    onEnableEditMode(id) {
      this.$router.push({
        name: "UpdateStaff",
        params: {
          objectId: id
        }
      });
    },
    exportObjects(type) {
      const params = {};
      const data = {};

      params.fields = this.columnsConfig.filter(el => el.isActive).map(el => el.key);

      if (params.fields.indexOf("widthLength") > -1) {
        params.fields.push("width", "length");
      }

      params.fields = params.fields.toString();

      if (type === "ids") {
        const ids = [];
        Object.keys(this.checkedItemIds).map(el => {
          if (this.checkedItemIds[el]) {
            ids.push(el);
          }
        });
        data.id = ids ? ids.toString() : null;
      }

      this.setUploadData(true);

      this.makeExport({
        params: params,
        data: data
      }).then(response => {
        this.setUploadData(false);

        if (type === "ids") {
          this.onCloseMultiChoose("ids");
        }

        if (response.status === 200) {
          saveAsXLSX(response.data, "Реестр__персонал_тко.xlsx");
        }
      });
    },
    onDeleteObject(employeeId) {
      const _vm = this;

      this.isActiveDeleting = true;
      this.removeElementFromList(employeeId);

      setTimeout(() => {
        if (_vm.deletingCanceled) {
          _vm.deletingCanceled = false;
          return;
        }

        _vm.setUploadData(true);

        _vm.deleteObject({ id: employeeId }).then(() => {
          axios.cancel("routes-staff");

          _vm.getObjectListData().then(response => {
            if (response && response.status && response.status === 200) {
              _vm.setUploadData(false);
            } else {
              if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
                _vm.setUploadData(false);
              }
            }
          });
        });
        _vm.isActiveDeleting = false;
      }, 4000);
    },
    onDeleteObjects() {
      const _vm = this;

      this.isActiveMultiChoose = false;
      this.isActiveDeleting = true;

      this.checkedTrIndex = [];
      $(".tr-elem-top").removeClass("tr-elem-top");
      $(".tr-elem-bottom").removeClass("tr-elem-bottom");

      const deleteIds = [];
      Object.keys(this.checkedItemIds).forEach(item => {
        if (this.checkedItemIds[item]) {
          deleteIds.push(Number(item));
          this.removeElementFromList(Number(item));
        }
      });
      this.setObjectList(
        this.objectsData.results.map(el => {
          el.isActive = false;
          return el;
        })
      );
      this.isActiveDeleting = true;

      setTimeout(() => {
        if (_vm.deletingCanceled) {
          _vm.deletingCanceled = false;
          return;
        }
        const deletePromises = [];

        _vm.setUploadData(true);

        deleteIds.map(id => {
          deletePromises.push(_vm.deleteObject({ id: id }));
        });

        Promise.all(deletePromises).then(() => {
          _vm.getObjectListData().then(response => {
            if (response && response.status && response.status === 200) {
              _vm.checkedItemIds = [];
              _vm.isActiveDeleting = false;
              _vm.setUploadData(false);
            } else {
              if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
                _vm.checkedItemIds = [];
                _vm.isActiveDeleting = false;
                _vm.setUploadData(false);
              }
            }
          });
        });
      }, 4000);
    },
    onCancelDeleting() {
      this.deletingCanceled = true;
      this.isActiveDeleting = false;

      axios.cancel("routes-staff");
      this.setUploadData(true);

      this.getObjectListData().then(response => {
        if (response && response.status && response.status === 200) {
          this.setUploadData(false);
        } else {
          if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
            this.setUploadData(false);
          }
        }
      });
    },
    closeDeleteInfo() {
      this.isActiveDeleting = false;
    },
    onSearchObjects() {
      this.setUploadData(true);
      this.searchObjects(this.smartFilterSelected).then(() => {
        this.setUploadData(false);
        // this.tablePage = 1;
        // TODO: Сбросить current page на 1
      });
    },
    onSortTable(column) {
      if (this.ordering.key === column.key) {
        this.ordering.type = this.ordering.type === "NONE" ? "ASC" : this.ordering.type === "ASC" ? "DESC" : "NONE";
      } else {
        this.ordering.type = "ASC";
      }
      this.ordering.key = column.key;

      axios.cancel("routes-staff");
      this.setUploadData(true);

      if (this.ordering.type === "NONE") {
        this.getObjectListData().then(response => {
          if (response && response.status && response.status === 200) {
            this.setUploadData(false);
          } else {
            if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
              this.setUploadData(false);
            }
          }
        });
      } else {
        const ordering = this.ordering.type === "ASC" ? `${column.key}` : `-${column.key}`;
        this.getObjectListData({ params: { ordering } }).then(response => {
          if (response && response.status && response.status === 200) {
            this.setUploadData(false);
          } else {
            if (axios.isCancel(response) && !axios.hasOpenRequest("routes-staff")) {
              this.setUploadData(false);
            }
          }
        });
      }
    },
    printItemData(itemData) {
      return itemData !== null ? itemData : "–";
    },
    getAllActiveColumnsCount() {
      let activeColumnsCount = 0;
      this.columnsConfig.forEach(s => {
        if (s.isActive) {
          activeColumnsCount++;
        }
      });
      return activeColumnsCount;
    },
    onSetChangeColumnsAll() {
      const activeColumnsCount = this.getAllActiveColumnsCount();
      if (activeColumnsCount === this.columnsConfig.length) {
        this.columnsConfig.map(s => {
          s.isActive = false;
          return s;
        });
      } else {
        this.columnsConfig.map(s => {
          s.isActive = true;
          return s;
        });
      }
    },
    onChangeActiveColumnConfig(column) {
      this.columnsConfig.map(s => {
        if (s.key === column.key) {
          s.isActive = !s.isActive;
        }
        return s;
      });
    },
    toggleTableConfig() {
      this.showTableConfigs = !this.showTableConfigs;
    },
    getPositionsNames(positions) {
      if (Array.isArray(positions) && positions.length > 0) {
        return positions.map(position => position.name).join(", ");
      }
      return "–";
    }
  }
};
</script>
